<template>
  <div :class="classnames" v-external-click="closeDropdown">
    <label :class="`${ns}__bar`">
      <span :class="`${ns}__bar-label`">
        {{ title }} <span class="label-count" v-if="totalFiltersActive">({{ totalFiltersActive }})</span>
        <span class="label-icon">
          <ToolTip :text="tooltipText" />
        </span>
      </span>
      <!-- <span :class="`${ns}__bar-label--mobile`"><svg-icon-filter /> Tags <span v-if="filtersActive.length"> ({{filtersActive.length}})</span></span> -->
      <span :class="`${ns}__bar-field`">
        <input
          :class="`${ns}__bar-input`"
          :type="`text`"
          :placeholder="`${placeholder}`"
          @blur="handleBlur"
          @click.prevent="filterToggle('open')"
          @focus="handleFocus"
          v-model="search"
          :ref="`_$input`"
        />
      </span>
    </label>

    <div :class="`${ns}__search-results`">
      <template v-if="filtersDropdown">
        <ul :class="`${ns}__search-results-list`">
          <template v-for="filter in filtersDropdown">
            <li :class="`${ns}__search-results-item`" :key="filter.id">
              <a
                :id="filter.id"
                :class="`${ns}__search-results-link`"
                :href="filter._links.self.href"
                @click.prevent="addActiveFilter($event, filter)"
              >
                {{ filter.title }}
              </a>
            </li>
          </template>
        </ul>
      </template>

      <template v-else-if="searching">
        <ul :class="`${ns}__search-results-list`">
          <li :class="`${ns}__search-results-item`">
            <span :class="`${ns}__category-no-results`">Loading...</span>
          </li>
        </ul>
      </template>

      <template v-else>
        <ul :class="`${ns}__search-results-list`">
          <li :class="`${ns}__search-results-item`">
            <span :class="`${ns}__category-no-results`">No Results</span>
          </li>
        </ul>
      </template>
    </div>
  </div>
</template>

<script>
  import ToolTip from '@/components/ToolTip'

  import SvgIconFilter from '@/svgs/SvgIconFilter'

  import { bem } from '@/mixins/bem.js'
  import { EventBus } from '@/utils/eventBus.js'
  import { helpers } from '@/mixins/helpers.js'
  import { productFilter } from '@/mixins/productFilter.js'

  const namespace = 'product-filter'

  export default {
    name: 'ProductFilter',
    components: {
      'svg-icon-filter': SvgIconFilter,
      ToolTip
    },
    mixins: [ bem, helpers, productFilter ],
    props: {
      filterType: String,
      isOnProductDetailPage: Boolean,
      placeholderText: {
        default: 'Start typing ...',
        type: String
      },
      title: String,
      tooltipText: String,
      totalFiltersActive: Number
    },
    data: function () {
      return {
        placeholder: this.placeholderText,
        tooltipContent: 'Helpful tips to go here.'
      }
    },
    created: function () {
      this.setNamespace(namespace)
    },
    methods: {
      closeDropdown () {
        this.search = ''
        this.filterToggle('close')
      },
      filterToggle (toggle) {
        let activeClass = 'filter-active'
        let activeToggle = 'active-toggle'
        let container = this.$el

        if (toggle === true) {
          if (container.classList.contains(activeToggle)) {
            container.classList.remove(activeToggle)
            container.classList.remove(activeClass)

            EventBus.$emit('tagfiltercollapsed')
          } else {
            container.classList.add(activeToggle)
            container.classList.add(activeClass)

            EventBus.$emit('tagfilterexpanded')
          }
        } else {
          if (toggle === 'close') {
            container.classList.remove(activeToggle)
            container.classList.remove(activeClass)

            EventBus.$emit('tagfiltercollapsed')
          }

          if (toggle === 'open') {
            container.classList.add(activeToggle)
            container.classList.add(activeClass)

            EventBus.$emit('tagfilterexpanded')
          }
        }
      },
      handleBlur () {
        this.placeholder = this.placeholderText
      },
      handleFocus () {
        this.loadSearch()
      }
    }
  }
</script>

<style lang="scss" scoped>
@import '../../scss/abstracts/__dir';
@import '../../scss/global/__dir';

$ns: '.product-filter';

#{$ns} {
  position: relative;
  transition: all 0.3s;
  flex-shrink: 0;

  .label-count {
    margin-left: 3px;
  }


  @include when-above($tablet) {
    // float: left;
    margin-right: 10px;
  }

  @include when-above($tablet-landscape) {
    margin-right: 15px;
  }

  &__bar {
    cursor: pointer;
    display: block;
  }

  &__bar-field {
    background-color: color('white');
    border-radius: $default-border-radius;
    border: 1px solid color('mercury');
    box-shadow: 0 2px 2px 0 rgba(0,0,0,0.04);
    display: block;
    width: 100%;
    background-image: url('../../assets/images/icon-magnify.svg');
    background-repeat: no-repeat;
    background-position: 15px center;


    @include when-above($tablet) {
      //width: 320px;
    }

    .filter-active & {
      //border-color: color('black');
      //color: color('black');
    }
  }

  &__bar-input {
    background-color: color('transparent');
    border: none;
    color: color('dusty-gray');
    display: inline-block;
    height: 50px !important;
    line-height: 50px !important;
    padding: 0 18px 0 37px !important;
    //width: 86px !important;
    transition: width 0.3s;

    font-size: 13px !important;
    @include breakpoint($desktop) {
      font-size: 15px !important;
    }

    &::placeholder {
      color: color('dusty-gray');
    }

    @include when-above($tablet) {
      width: 100%;
    }

    .filter-active & {
      //color: color('black');

      &::placeholder {
        //color: color('black');
      }

      @include when-below($tablet) {
        &::placeholder {
          color: transparent;
        }

        // width: calc(100vw - 40px) !important;
      }
    }
  }

  &__bar-label {
    color: color('black');
    font-family: $font-primary-medium;
    font-size: 14px;
    margin-bottom: 10px;
    display: flex;
    align-items: center;

    @include when-below($tablet) {
      // display: none;
    }
  }

  .label-icon {
    margin-left: 6px;
    display: none;
    @include breakpoint($desktop) {
      display: block;
    }
  }

  &__bar-label--mobile {
    background-color: color('white');
    bottom: 1px;
    color: color('black');
    font-family: $font-primary-medium;
    font-size: 14px;
    left: 1px;
    line-height: 40px;
    padding-left: 14px;
    position: absolute;
    right: 1px;
    top: 1px;
    transition: opacity 0.3s;
    pointer-events: none;

    @include when-above($tablet) {
      opacity: 0;
    }

    .filter-active & {
      opacity: 0;
    }

    svg {
      margin-right: 6px;
      transform: translate3d(0,2px,0);
    }
  }

  &__category-no-results {
    color: #9f9f9f;
    display: block;
    font-size: 14px;
    height: 34px;
    line-height: 34px;
    padding: 0 5px;


    @include when-above($tablet) {
      padding: 0 8px;
    }

    @include when-above($tablet-landscape) {
      padding: 0 13px;
    }
  }

  /*
   * TODO
   * address the mobile look of this
  */
  &__search-results {
    background: $white;
    border-color: $border-color;
    border-radius: 0 0 3px 3px;
    border-style: solid;
    border-width: 0 1px 1px;
    display: block;
    max-height: 318px;
    overflow-y: auto;
    box-shadow: 0 0 10px 0 color('black', 0.1);
    position: absolute;
    width: 100%;
    z-index: 6;
    transform: translate3d(0, 10px, 0);
    opacity: 0;
    visibility: hidden;

    .no-hiddenscroll & {
      @include scrollbars;
    }

    @include when-above($tablet) {
      border-radius: 3px;
      border-width: 1px;
      display: block !important;
      margin-top: 4px;
      opacity: 0;
      // top: 100%;
      transition: opacity 0.3s, visibility 0.3s;
      transform: none;
      visibility: hidden;
    }

    .filter-active & {
      opacity: 1;
      visibility: visible;
    }

    @include when-above($tablet) {
      // left: 0;
      width: 100%;
    }

    @include when-above($tablet-landscape) {
      //max-width: 290px;
    }
  }

  &__search-results-link {
    border-radius: 3px;
    color: color('black');
    display: block;
    font-size: 14px;
    height: 34px;
    line-height: 34px;
    padding: 0 5px;
    transition: background-color 0.3s, color 0.3s;

    @include hover {
      background: color('black');
      color: $white;
    }

    @include when-above($tablet) {
      padding: 0 8px;
    }

    @include when-above($tablet-landscape) {
      padding: 0 13px;
    }
  }

  &__search-results-list {
    padding: 15px 6px;

    @include when-above($tablet) {
      padding-left: 8px;
      padding-right: 8px;
    }

    @include when-above($tablet-landscape) {
      padding-left: 11px;
      padding-right: 11px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/js/components/ProductFilter.vue